module.exports = __webpack_public_path__ + "img/8b1251a691b4d544bbe14ac2d5eb7a97.png";